import { useContext } from 'react';
import { CurrentUserContext } from '../providers/AuthUserProvider';

export const useCurrentUserContext = () => {
  return useContext(CurrentUserContext);
};
